const ContactListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 150
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 300
  },
  {
    title: 'Description',
    dataIndex: 'description',
    width: 300
  },
  {
    title: 'Email',
    dataIndex: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    width: 300
  },
  {
    title: 'SMS',
    dataIndex: 'sms',
    width: 300
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 100
  }
];

export { ContactListColumn };